import {useTranslation} from '@aboutyou/i18n';
import {
  GenericIconName,
  Icon,
  Notification,
  Text,
} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled from 'styled-components';

export const ErrorNotification: FC<{
  isShown: boolean;
}> = ({isShown}) => {
  const {t} = useTranslation();

  return (
    <StyledNotification
      type="FAILURE"
      isShown={isShown}
      dataTestid="addToBasketErrorNotification"
    >
      <MessageWrapper>
        <Icon size="S" asset={GenericIconName.Error} fill="#ffffff" />
        <Text color="White" size="px14">
          {t('Please choose a size first')}
        </Text>
      </MessageWrapper>
    </StyledNotification>
  );
};

const MessageWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
`;

const StyledNotification = styled(Notification)`
  margin-top: 12px !important;
  margin-bottom: -43px;
`;
